"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Dialog = require("../../components/Dialog/Dialog.styles");
var _Mask = require("../../components/Mask/Mask.styles");
var _overflowAutoMixin = require("../overflowAutoMixin");
/** @class ModalMixin */
/** @method */
var ModalMixin = function ModalMixin(props) {
  return (0, _styledToken.default)({
    boxShadow: 'Modal.boxShadow',
    paddingHorizontal: 'Modal.viewportPaddingHorizontal',
    paddingVertical: 'Modal.viewportPaddingVertical',
    zIndex: 'Modal.zIndex'
  }, function (_ref) {
    var boxShadow = _ref.boxShadow,
      paddingHorizontal = _ref.paddingHorizontal,
      paddingVertical = _ref.paddingVertical,
      zIndex = _ref.zIndex;
    return (0, _styledComponents.css)(["position:fixed;top:0;left:0;z-index:", ";height:100%;width:100%;", " box-sizing:border-box;padding:", "px ", "px;> ", "{position:fixed;top:0;left:0;height:100%;width:100%;z-index:1;}display:flex;justify-content:center;align-items:center;> ", "", "{z-index:2;box-shadow:", ";}"], zIndex, (0, _overflowAutoMixin.overflowAutoMixin)(props), paddingVertical, paddingHorizontal, _Mask.StyledMask, _Dialog.StyledDialog, _Dialog.StyledDialog, boxShadow);
  })(props);
};
exports.ModalMixin = ModalMixin;